import { Field, ID, InputType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import { ActionArgs } from '../../action/ActionArgs'
import type { AiUsage } from '../args/AiUsage'
import type { CreditTransaction } from './CreditTransaction'

@InputType()
export class RecordAndDebitAiUsageArgs extends ActionArgs {
  /** Generic owner of the balance — a `User._id` or `Tenant._id`, per `resolveBillingOwnerId`. */
  @Field(() => ID)
  ownerId: string

  @Field(() => String)
  feature: string

  @Field(() => GraphQLJSON)
  usage: AiUsage

  /** Deterministic idempotency key for a caller that may retry the same billable unit of work (e.g. `${batchId}:${chunkIndex}`). */
  @Field(() => String, { nullable: true })
  chargeKey?: string

  /** Caller-supplied human-readable description of the charge, forwarded to both `RecordAiUsage` and `DebitCredits`. */
  @Field(() => String, { nullable: true })
  remarks?: string
}

/**
 * Composes `RecordAiUsage` + `DebitCredits` — the identical two-call sequence every metered
 * AI call site needs (price the call, then debit the priced credits). Cross-module consumers
 * (e.g. QuickScore) inject this by `IocKey.ai.service.recordAndDebitAiUsage`, typed via this
 * interface — the concrete class stays internal to `ai-node`.
 */
export interface IRecordAndDebitAiUsage {
  execute(args: RecordAndDebitAiUsageArgs): Promise<CreditTransaction>
}
